import "../../../resources/less/Family/ThemePages/BackToSchool.less";
import BaseThematique from "./BaseThematique";

class BackToSchool extends BaseThematique {
  constructor() {
    super();
  }
}

$(window).on("load", () => {
  new BackToSchool();
});
